// export const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const EMAIL_REGEX = /^[\w\-\.!#$%&'*+/=?^_`{|}~]+@([\w-]+\.)+[\w-]{2,4}$/;